<p-toast></p-toast>
<div class="body">
    <app-left-menu></app-left-menu>
    <div class="apps-right">
        <div class="page-container">
            <div class="inner-page-container">
                <div class="white">
                    <div class="page-title">
                        <div class="row">
                            <div class="col-md-5">
                                <h3>Agent Enquiry</h3>
                            </div>
                            <div class="col-md-7 text-right">
                                <div class="action-btn">                          
                                    <button pButton pRipple label="" icon="las la-plus" title="Add" class="p-button-success p-mr-2"></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container scroll-y">
                        <table class="normal-table">
                            <tr>
                                <td style="width:17%" class="text-right">
                                    Agent Name <span class="hlt-txt">*</span>
                                </td>
                                <td style="width:50%" colspan="3">
                                    <input type="text" pInputText>
                                </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right">Father's Name <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">Mobile No <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">E-Mail ID <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                            </tr>
                            <tr>
                                <td class="text-right" rowspan="2">Door No. & Street <span class="hlt-txt">*</span></td>
                                <td rowspan="2"><textarea inputId="textarea" rows="2" cols="30" pInputTextarea></textarea></td>
                                <td class="text-right">Pincode <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td class="text-right">State <span class="hlt-txt">*</span></td>
                                <td><p-dropdown [filter]="true" optionLabel="name"></p-dropdown></td>
                            </tr>
                            <tr>
                                <td class="text-right">District <span class="hlt-txt">*</span></td>
                                <td><p-dropdown [filter]="true" optionLabel="name"></p-dropdown></td>
                                <td class="text-right">City <span class="hlt-txt">*</span></td>
                                <td><p-dropdown [filter]="true" optionLabel="name"></p-dropdown></td>
                            </tr>
                            <tr>
                                <td class="text-right">Educational Qualification <span class="hlt-txt">*</span></td>
                                <td><p-dropdown [filter]="true" optionLabel="name"></p-dropdown></td>
                                <td class="text-right">Other Qualification <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText> </td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td class="text-right">Location Interested <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Referred By <span class="hlt-txt">*</span></td>
                                <td><p-dropdown [filter]="true" optionLabel="name"></p-dropdown></td>
                                <td class="text-right">Referred By Name <span class="hlt-txt">*</span></td>
                                <td><p-dropdown [filter]="true" optionLabel="name"></p-dropdown></td>
                            </tr>
                            <tr>
                                <td class="text-right">Experience if Any (in years) <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Current Agency Status if any <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Potential in your area (In Rs) <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                            </tr>
                            <tr>
                                <td class="text-right">Truck details (Own / Lease) <span class="hlt-txt">*</span></td>
                                <td><p-dropdown [filter]="true" optionLabel="name"></p-dropdown></td>
                                <td class="text-right">Number of Vehicles <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                                <td class="text-right">Present Business Size <span class="hlt-txt">*</span></td>
                                <td><input type="text" pInputText></td>
                            </tr>
                            <tr>
                                <td class="text-right">Interview Date <span class="hlt-txt">*</span></td>
                                <td><p-calendar dateFormat="dd/mm/yy" [showIcon]="true"></p-calendar></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                            </tr>
                            <tr>
                                <td colspan="6" class="text-center">
                                    <button pButton label="Save" class="p-button-success" icon="las la-check"></button>
                                    <button pButton label="Clear" class="p-button-warning" icon="las la-broom"></button>
                                </td>
                            </tr>
                        </table>
                        <div class="card">
                            <p-toolbar styleClass="p-mb-4">
                                <ng-template pTemplate="left">
                                    <span class="p-input-icon-left">
                                        <i class="las la-search"></i>
                                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                        placeholder="Search..." />
                                    </span>
                                </ng-template>
        
                                <ng-template pTemplate="right">
                                    <button type="button" pButton pRipple icon="las la-file-excel" title="Export to Excel" class="p-button-success p-mr-2" pTooltip="XLS"
                                        tooltipPosition="bottom"></button>
                                </ng-template>
                            </p-toolbar>
        
                            <p-table #dt [value]="agentListGrid" [scrollable]="true" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,25,50,100]"
                                [globalFilterFields]="['agentNo','agentName','fatherName','mobileNo']" [style]="{'overflow':'auto!important'}"
                                [rowHover]="true" dataKey="id"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true" scrollHeight="200px">
                                <ng-template pTemplate="colgroup" let-columns>
                                    <colgroup>
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:100px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:150px">
                                        <col style="width:150px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                        <col style="width:250px">
                                    </colgroup>
                                </ng-template>
                                <ng-template pTemplate="header">
                                    <tr>                                
                                        <th pSortableColumn="agentNo">Agent No <p-sortIcon field="agentNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="agentName">Agent Name <p-sortIcon field="agentName"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="fatherName">Father Name <p-sortIcon field="fatherName"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">E-Mail ID <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Door Street No <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">City <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">State <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                        <th pSortableColumn="mobileNo">Mobile No <p-sortIcon field="mobileNo"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-_agentListGrid>
                                    <tr>
                                        <td>
                                            {{_agentListGrid.agentNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.agentName}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.fatherName}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                        <td>
                                            {{_agentListGrid.mobileNo}}
                                        </td>
                                    </tr>
                                </ng-template>
                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>